<template>
  <div>
    <div v-for="(t, tinx) in data" :ke="`tr-${tinx}`">
      <v-container grid-list-md>
        <v-layout row wrap>
          <v-flex xs12>
            <v-chip label color="green lighten-5">{{ t.nombre }}</v-chip>
            <v-chip label small class="caption">{{ t.tipo }}</v-chip>
            <v-chip label small v-if="isTraslado">
              <v-icon color="green lighten-2" small v-if="t.direccion == 'I'" title="hola">fas fa-arrow-right</v-icon>
              <v-icon color="red lighten-1" small v-else-if="t.direccion == 'O'">fas fa-arrow-left</v-icon>
              <v-icon color="yellow darken-4" small v-else>fas fa-arrows-alt-h</v-icon>
            </v-chip>
          </v-flex>
          <v-flex xs6 sm3 v-for="(tp, tpinx) in t.tarifaPasajeros" :key="`tp-${tpinx}`">
            <v-card dark color="grey lighten-2" class="black--text">
              <v-card-text class="pa-0 py-1 font-weight-light caption">
                <p class="text-center my-0">
                  Tarifa por persona
                  <span v-if="tp.cantidadPax > 1">para {{ tp.cantidadPax }} pasajeros</span>
                </p>
                <v-container fluid class="pa-1">
                  <v-layout row wrap class="text-center text-uppercase font-weight-regular">
                    <v-flex xs6 v-for="(tr, trinx) in tp.tarifas" :key="`trt-${trinx}`">
                      <p class="mb-0">{{ tr["@attributes"].tipo }}</p>
                      <p class="mb-0" v-if="tr.venta >= 1 && tr.moneda === 'PES'">
                        {{ tr.moneda }} {{ sumarIva(tr.venta, tr.iva).toFixed(2) }}
                      </p>
                      <p class="mb-0" v-else-if="tr.venta >= 1 && tr.moneda !== 'PES'">
                        {{ tr.moneda }} {{ tr.venta }}
                      </p>
                      <p class="text-center mb-0 green--text darken-4" v-else>Free</p>
                    </v-flex>
                  </v-layout>
                </v-container>
                <p
                  v-bind:class="{
                    'text-center': true,
                    'my-0': tp.minimoPax != 0
                  }"
                >
                  <span v-if="tp.minimoPax > 1">Mínimo {{ tp.minimoPax }} personas</span>
                </p>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </div>
</template>
<script>
// ESTE COMPONENTE ES INSERTADO AL DOM DE DESCRIPCION VIA REF, POR LO QUE LA
// MODIFICACION POCA VECES SE VERÁ REFLEJADA POR EL HOT RELOAD
export default {
  name: "panelTrasladoTable",
  props: {
    data: {
      type: Array,
      required: true
    },
    isTraslado: {
      type: Boolean,
      default: true
    }
  },
  components: {},
  mounted() {},
  created() {},
  methods: {
    sumarIva(venta, iva) {
      let total = parseFloat(venta) + parseFloat(iva)
      return total
    }
  },
  data() {
    return {
      items: []
    }
  },
  computed: {}
}
</script>
<style scoped>
table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

tr:nth-child(even) {
  background-color: #dddddd;
}
</style>
